package org.chiangmeng.qfast.core.ui.theme

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import org.chiangmeng.qfast.core.domain.models.AppTheme

class ThemeManager {
    private val _theme = MutableStateFlow(AppTheme.AMBER)
    val theme: StateFlow<AppTheme> = _theme.asStateFlow()

    fun setTheme(theme: AppTheme) {
        _theme.value = theme
    }
}
